import React from "react";
import Header from "../Component/header";
import Slider from "../Component/Slider";
import Nurture from "../Component/Nurture";
import Slider2 from "../Component/Slider2";
import { FaArrowTurnUp } from "react-icons/fa6";

function Home() {
  return (
    <div>
      <Slider2 />
      <Nurture />
      <span className="go-top">
        <button
          type="button"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        >
          <FaArrowTurnUp />
        </button>
      </span>
    </div>
  );
}

export default Home;
